// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M16 0.5H8V3H3V23.5H21V3H16V0.5ZM16 14.5H13V17.5H11V14.5H8V12.5H11V9.5H13V12.5H16V14.5Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-battery-add-filled')
export default class BatteryAddFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'battery-add-filled',
    }
  }
}
